import { commandCounsellorGroupsAdd } from "./command-counsellor-groups-add/command-counsellor-groups-add.module";
import { commandCounsellorGroupsMain } from "./command-counsellor-groups-main/command-counsellor-groups-main.module";
import { commandCounsellorGroupsEdit } from "./command-counsellor-groups-edit/command-counsellor-groups-edit.module";
import { commandCounsellorGroupsList } from "./command-counsellor-groups-list/command-counsellor-groups-list.module";
import { commandCounsellorGroupsDetails } from "./command-counsellor-groups-details/command-counsellor-groups-details.module";
import { commandCounsellorAdd } from "./command-counsellor-groups-details/command-counsellor-add/command-counsellor-add.module";

import { CommandCounsellorGroupsService } from "./command-counsellor-groups.service";

export const commandCounsellorGroups = angular
  .module("components.command-counsellor-groups-main", [
    commandCounsellorGroupsMain,
    commandCounsellorGroupsList,
    commandCounsellorGroupsAdd,
    commandCounsellorGroupsEdit,
    commandCounsellorGroupsDetails,
    commandCounsellorAdd
    
  ])
  .service("CommandCounsellorGroupsService", CommandCounsellorGroupsService).name;


// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-groups/command-counsellor-groups.module.js